/* global Html5Qrcode */

angular.module('app').directive('ngEnter', function() {
  return function(scope, element, attrs) {
    element.bind('keydown keypress', function(event) {
      if (event.which === 13) {
        scope.$apply(function() {
          scope.$eval(attrs.ngEnter);
        });
        event.preventDefault();
      }
    });
  };
});

angular.module('app').directive('autoSubmitForm', ['$interpolate', function($interpolate) {
  return {
    replace: true,
    scope: {},
    template: '',
    link: function($scope, element, $attrs) {
      $scope.$on($attrs.event, function(event, eventArgs) {
        var formString='<form action="'+eventArgs.redirect+'" method="POST">';
        for(var i in eventArgs.postFields) {
          formString+='<input name="'+i+'" type="hidden" value="'+eventArgs.postFields[i]+'"/>';
        }
        formString+='</form>';
        var form = $interpolate(formString)($scope);
        angular.element(form).appendTo('body').submit();
      });
    }
  };
}]);

angular.module('app').directive('qrScanner', ['$timeout','$log','$window','tools','parameters', function($timeout,$log,$window,tools,parameters) {
  return {
    restrict: 'E',
    template: `
      <div>
        <div id="qr-reader" style="width: 100%;"></div>
      </div>
    `,
    link: function($scope) {
      $scope.qrResult='';

      var qrCodeSuccessCallback = function(decodedText) {
        $timeout(function() {
          $scope.qrResult = decodedText;
          var regex=new RegExp(parameters.FFO[$scope.ffo].field13);
          if(regex.test(decodedText)) {
            $window.location.href=decodedText;
          } else {
            $scope.formError=true;
          }
        });
      };

      var config = {
        fps:30,
        qrbox:250,
        aspectRatio:1
      };

      var html5QrCode = new Html5Qrcode('qr-reader');
      html5QrCode.start(
        {facingMode:'environment'},
        config,
        qrCodeSuccessCallback
      ).catch(err => {
        $log.error('QR Code scanning failed.',err);
      });

      $timeout(function() {
        html5QrCode.applyVideoConstraints({
          focusMode:'continuous',
          advanced:[{zoom:3}]
        });
      },2000);

      // Optional: Cleanup on destroy
      $scope.$on('$destroy', function() {
        html5QrCode.stop().then(function() {
          html5QrCode.clear();
        }).catch(err => {
          $log.error('Failed to stop QR scanner',err);
        });
      });
    }
  };
}]);
